import e_commerce from "./e-commerce.png"
import netflex_app from "./netflix-movie-app.jpg"
import food_app from "./food-app.png"
import tesla_overlay from "./Tesla.png"
import image_generator from "./back.jpg"
import klapper from "./klp.png"
import Codex from "./codex.png"

export const PROJECTS_IMAGES = {
  e_commerce,
  netflex_app,
  food_app,
  tesla_overlay,
  image_generator,
  klapper,
  Codex
}
